import { render, staticRenderFns } from "./VideoEmbed.vue?vue&type=template&id=1566c74a&scoped=true&lang=pug"
import script from "./VideoEmbed.vue?vue&type=script&lang=js"
export * from "./VideoEmbed.vue?vue&type=script&lang=js"
import style0 from "./VideoEmbed.vue?vue&type=style&index=0&id=1566c74a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1566c74a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1566c74a')) {
      api.createRecord('1566c74a', component.options)
    } else {
      api.reload('1566c74a', component.options)
    }
    module.hot.accept("./VideoEmbed.vue?vue&type=template&id=1566c74a&scoped=true&lang=pug", function () {
      api.rerender('1566c74a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/video/VideoEmbed.vue"
export default component.exports